import type { IconSvgObject } from './types';

const Logout03Icon: IconSvgObject = [
  ["path", { d: "M18 6V4C18 2.89543 17.1046 2 16 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H16C17.1046 22 18 21.1046 18 20V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 16.5L20 12L14.5 7.5V10.5H9V13.5H14.5V16.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Logout03Icon;
